import { Dialog, Button, Box, Text, Stack } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import CautionIcon from './caution-icon.svg?react'

type Props = {
  visible: boolean
  onClose: () => void
  width?: 'small' | 'content' | 'xsmall' | 'medium' | 'large' | 'xlarge' | undefined
  actionType?: 'verify' | 'cancel'
  handleBackPropFunction: () => void
  setActionType: (actionType: 'verify' | 'cancel' | null) => void
  submitCreditCheck: () => void
}

const CreditCheckModal = ({
  width,
  visible,
  onClose,
  actionType,
  setActionType,
  handleBackPropFunction,
  submitCreditCheck
}: Props) => {
  const { t } = useTranslation()

  const onConfirmHandler = () => {
    submitCreditCheck()
    setActionType(null)
    onClose()
  }

  if (!actionType) return undefined

  const isVerify = actionType === 'verify'

  const title = isVerify
    ? t('r.profile.edit_confirm_modal_title', 'Please confirm:')
    : t('r.profile.edit_go_back_modal_title', 'Are you sure?')
  const description = isVerify
    ? t(
        'r.profile.edit_confirm_modal_text',
        'I agree that the information in this application is true and accurate, and that the Landlord may terminate a Tenancy Agreement if any of the information submitted is proven untrue, incomplete, misleading, or fraudulent.'
      )
    : t('r.profile.edit_go_back_modal_text', 'Changes you made will not be saved.')

  return (
    <Dialog
      id="credit-check-modal"
      open={visible}
      onClose={onClose}
      width={width}
      title={title}
      description={
        <Text size="standard" align="center">
          {description}
        </Text>
      }
      illustration={<CautionIcon />}
    >
      <Stack space="large">
        <Box display="flex" alignItems="center" gap="xsmall" width="full">
          {isVerify ? (
            <Button variant="solid" onClick={onConfirmHandler}>
              {t('l.application.view.i_confirm.button', 'I Confirm')}
            </Button>
          ) : (
            <>
              <Button variant="transparent" size="small" onClick={onClose}>
                {t('common.cancel', 'Cancel')}
              </Button>
              <Button variant="solid" onClick={handleBackPropFunction}>
                {t('common.continue', 'Continue')}
              </Button>
            </>
          )}
        </Box>
      </Stack>
    </Dialog>
  )
}

export default CreditCheckModal
